import { Query } from "@datorama/akita";
import { singleton } from "tsyringe";

import BaseStore from "./BaseStore";
import type { BaseStoreState } from "./BaseStore";

@singleton()
class BaseQuery<S> extends Query<BaseStoreState & S> {
    constructor(protected store: BaseStore<S>) {
        super(store);
    }

    selectStatus() {
        return this.select((state) => state.status);
    }
}

export default BaseQuery;
